/**
 * 指标列表
 */
import React from 'react';

import styles from './index.module.scss';

export interface IndicatorItem {
  name: string;
  label: string;
  icon: string;
  iconHeight?: number; // 图标高度
  content: React.ReactNode;
}

interface IProps {
  items: IndicatorItem[];
}

const Index: React.FC<IProps> = (props) => {
  const list = props.items || [];

  const getIconStyle = (item: IndicatorItem) => {
    if (item.iconHeight) {
      return { height: item.iconHeight };
    }
    return {};
  };

  if (list.length) {
    return (
      <ul className={styles.indicatorList}>
        {list.map((item) => {
          return (
            <li className={styles.indicatorItem} key={item.name}>
              <div className={styles.itemContent}>
                <div className={styles.contentLabel}>{item.label}</div>
                <div className={styles.contentValue}>{item.content ?? '-'}</div>
              </div>
              <img
                className={styles.itemIcon}
                style={getIconStyle(item)}
                src={item.icon}
                alt={item.label}
              />
            </li>
          );
        })}
      </ul>
    );
  }

  return null;
};

export default Index;
